"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputHeaderView = exports.Asterisk = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _react = _interopRequireDefault(require("react"));
var _layout = require("../../layout");
var _text = require("../../text");
var _utils = require("../../utils");
var _react2 = require("@emotion/react");
const AsteriskBase = /*#__PURE__*/(0, _base.default)(_text.Text.withComponent('span', process.env.NODE_ENV === "production" ? {
  target: "e1ghu7d2"
} : {
  target: "e1ghu7d2",
  label: "AsteriskBase"
}), process.env.NODE_ENV === "production" ? {
  target: "e1ghu7d1"
} : {
  target: "e1ghu7d1",
  label: "AsteriskBase"
})(_ref => {
  let {
    color
  } = _ref;
  return {
    color,
    marginLeft: _utils.LABEL_ASTERISK_SPACING
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9zdWJtb2R1bGVzL2lucHV0L2lucHV0LWhlYWRlci9oZWxwZXJDb21wb25lbnRzLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFnQnFCIiwiZmlsZSI6Ii4uLy4uLy4uLy4uL3NyYy9zdWJtb2R1bGVzL2lucHV0L2lucHV0LWhlYWRlci9oZWxwZXJDb21wb25lbnRzLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5cbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcblxuaW1wb3J0IHsgVmlldyB9IGZyb20gJy4uLy4uL2xheW91dCc7XG5pbXBvcnQgeyBUZXh0IH0gZnJvbSAnLi4vLi4vdGV4dCc7XG5pbXBvcnQge1xuICBERUZBVUxUX1NQQUNFX0JFVFdFRU5fSUNPTixcbiAgTEFCRUxfQVNURVJJU0tfU1BBQ0lORyxcbiAgcHhcbn0gZnJvbSAnLi4vLi4vdXRpbHMnO1xuXG5pbnRlcmZhY2UgQXN0ZXJpc2tQcm9wcyB7XG4gIGNvbG9yOiBzdHJpbmc7XG59XG5cbmNvbnN0IEFzdGVyaXNrQmFzZSA9IHN0eWxlZChUZXh0LndpdGhDb21wb25lbnQoJ3NwYW4nKSk8QXN0ZXJpc2tQcm9wcz4oXG4gICh7IGNvbG9yIH0pID0+ICh7XG4gICAgY29sb3IsXG4gICAgbWFyZ2luTGVmdDogTEFCRUxfQVNURVJJU0tfU1BBQ0lOR1xuICB9KVxuKTtcblxuZXhwb3J0IGNvbnN0IEFzdGVyaXNrID0gKHsgY29sb3IgfTogQXN0ZXJpc2tQcm9wcykgPT4gKFxuICA8QXN0ZXJpc2tCYXNlIGFyaWEtaGlkZGVuPVwidHJ1ZVwiIGNvbG9yPXtjb2xvcn0+XG4gICAgKlxuICA8L0FzdGVyaXNrQmFzZT5cbik7XG5cbmV4cG9ydCBjb25zdCBJbnB1dEhlYWRlclZpZXcgPSBzdHlsZWQoVmlldykoe1xuICBsYWJlbDoge1xuICAgIG1hcmdpbklubGluZTogYDAgJHtweChERUZBVUxUX1NQQUNFX0JFVFdFRU5fSUNPTil9YCxcbiAgICAnJiA+IConOiB7XG4gICAgICBkaXNwbGF5OiAnaW5saW5lJyxcbiAgICAgIHZlcnRpY2FsQWxpZ246ICdtaWRkbGUnXG4gICAgfVxuICB9XG59KTtcbiJdfQ== */");
const Asterisk = _ref2 => {
  let {
    color
  } = _ref2;
  return (0, _react2.jsx)(AsteriskBase, {
    "aria-hidden": "true",
    color: color
  }, "*");
};
exports.Asterisk = Asterisk;
const InputHeaderView = exports.InputHeaderView = /*#__PURE__*/(0, _base.default)(_layout.View, process.env.NODE_ENV === "production" ? {
  target: "e1ghu7d0"
} : {
  target: "e1ghu7d0",
  label: "InputHeaderView"
})({
  label: {
    marginInline: "0 ".concat((0, _utils.px)(_utils.DEFAULT_SPACE_BETWEEN_ICON)),
    '& > *': {
      display: 'inline',
      verticalAlign: 'middle'
    }
  }
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9zdWJtb2R1bGVzL2lucHV0L2lucHV0LWhlYWRlci9oZWxwZXJDb21wb25lbnRzLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUE2QitCIiwiZmlsZSI6Ii4uLy4uLy4uLy4uL3NyYy9zdWJtb2R1bGVzL2lucHV0L2lucHV0LWhlYWRlci9oZWxwZXJDb21wb25lbnRzLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5cbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcblxuaW1wb3J0IHsgVmlldyB9IGZyb20gJy4uLy4uL2xheW91dCc7XG5pbXBvcnQgeyBUZXh0IH0gZnJvbSAnLi4vLi4vdGV4dCc7XG5pbXBvcnQge1xuICBERUZBVUxUX1NQQUNFX0JFVFdFRU5fSUNPTixcbiAgTEFCRUxfQVNURVJJU0tfU1BBQ0lORyxcbiAgcHhcbn0gZnJvbSAnLi4vLi4vdXRpbHMnO1xuXG5pbnRlcmZhY2UgQXN0ZXJpc2tQcm9wcyB7XG4gIGNvbG9yOiBzdHJpbmc7XG59XG5cbmNvbnN0IEFzdGVyaXNrQmFzZSA9IHN0eWxlZChUZXh0LndpdGhDb21wb25lbnQoJ3NwYW4nKSk8QXN0ZXJpc2tQcm9wcz4oXG4gICh7IGNvbG9yIH0pID0+ICh7XG4gICAgY29sb3IsXG4gICAgbWFyZ2luTGVmdDogTEFCRUxfQVNURVJJU0tfU1BBQ0lOR1xuICB9KVxuKTtcblxuZXhwb3J0IGNvbnN0IEFzdGVyaXNrID0gKHsgY29sb3IgfTogQXN0ZXJpc2tQcm9wcykgPT4gKFxuICA8QXN0ZXJpc2tCYXNlIGFyaWEtaGlkZGVuPVwidHJ1ZVwiIGNvbG9yPXtjb2xvcn0+XG4gICAgKlxuICA8L0FzdGVyaXNrQmFzZT5cbik7XG5cbmV4cG9ydCBjb25zdCBJbnB1dEhlYWRlclZpZXcgPSBzdHlsZWQoVmlldykoe1xuICBsYWJlbDoge1xuICAgIG1hcmdpbklubGluZTogYDAgJHtweChERUZBVUxUX1NQQUNFX0JFVFdFRU5fSUNPTil9YCxcbiAgICAnJiA+IConOiB7XG4gICAgICBkaXNwbGF5OiAnaW5saW5lJyxcbiAgICAgIHZlcnRpY2FsQWxpZ246ICdtaWRkbGUnXG4gICAgfVxuICB9XG59KTtcbiJdfQ== */");